export const UPDATE_LAST_VISITED_DEAL_MUTATION = `
  mutation UpdateLastVisitedDealMutation($offerId: ID!, $options: OfferOptions) {
    me {
      updateLastVisited(offerId: $offerId, options: $options)
    }
  }
`;
